'use client'

import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { useRouter } from '@/routing'
import { ArrowXAxisIcon } from '@/shared/icons/arrow-x-axis-icon'
import style from './breadcrumbs.module.scss'

export const BackButton = () => {
  const router = useRouter()
  const translate = useTranslations()

  return (
    <div className={clsx(style.backButton, 'text text_type_d text_color_white-060')} onClick={router.back}>
      <ArrowXAxisIcon direction="prev" />
      <span>{translate('buttonBack')}</span>
    </div>
  )
}
